var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeIsClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.1087 13.8913C1.61721 11.8301 0 9 0 9C0 9 4 2 13 2C14.3045 2 15.504 2.14706 16.6014 2.39856L13.8987 5.10135C13.6098 5.03503 13.309 5 13 5C10.7909 5 9 6.79086 9 9C9 9.30899 9.03503 9.60979 9.10135 9.89865L5.1087 13.8913ZM9.39856 15.6014C10.496 15.8529 11.6955 16 13 16C22 16 26 9 26 9C26 9 24.3828 6.16989 20.8913 4.1087L16.8987 8.10135C16.965 8.39021 17 8.69101 17 9C17 11.2091 15.2091 13 13 13C12.691 13 12.3902 12.965 12.1013 12.8987L9.39856 15.6014ZM16 9C16 9.76777 15.7071 10.5355 15.1213 11.1213C14.5355 11.7071 13.7678 12 13 12L16 9ZM13 6C12.2322 6 11.4645 6.29289 10.8787 6.87868C10.2929 7.46447 10 8.23223 10 9L13 6ZM21 0L4 17L5 18L22 1L21 0Z",
    fill: "#BDBDBD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIsClose);
export default __webpack_public_path__ + "static/media/eye_is_close.02270032.svg";
export { ForwardRef as ReactComponent };